import type { LucideIcon } from 'lucide-react'
import { ClipboardList, SlidersHorizontal, Truck } from 'lucide-react'

import { ROUTES } from '@/constants'

export type Screen = {
  route: string
  /** Sidebar label; also the page h1 for placeholder screens. */
  label: string
  icon: LucideIcon
  /** Sidebar group, in display order of first appearance. */
  group: string
  /** Board story that delivers the real screen (placeholder pages cite it). */
  storyId: number
}

/**
 * Single source of truth for routed screens: App.tsx derives the route table
 * and AppSidebar derives the grouped navigation from this list.
 *
 * Additive: a screen is added here by the story that delivers it, not ahead
 * of time, so the navigation only shows what the app actually does. Today,
 * Reconcile, Yard inventory and History were removed by #126800; their own
 * stories re-add them with the real page.
 */
export const SCREENS: Screen[] = [
  {
    route: ROUTES.DELIVERIES,
    label: 'Deliveries',
    icon: Truck,
    group: 'Daily loop',
    storyId: 121556,
  },
  {
    route: ROUTES.RECEIVING,
    label: 'Receiving',
    icon: ClipboardList,
    group: 'Daily loop',
    storyId: 121557,
  },
  {
    route: ROUTES.SETUP,
    label: 'Site setup',
    icon: SlidersHorizontal,
    group: 'Configure',
    storyId: 121560,
  },
]

/** SCREENS grouped for the sidebar, preserving first-appearance order. */
export function screensByGroup(): { label: string; items: Screen[] }[] {
  const groups: { label: string; items: Screen[] }[] = []
  for (const screen of SCREENS) {
    let group = groups.find((g) => g.label === screen.group)
    if (!group) {
      group = { label: screen.group, items: [] }
      groups.push(group)
    }
    group.items.push(screen)
  }
  return groups
}
